require('./bootstrap');

import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

window.Tagify = require('@yaireo/tagify')
window.Vue = require('vue')
window.Sortable = require('sortablejs').default
window.draggable = require('vuedraggable')
window.jsPDF = require('jspdf').default
window.bootstrap = bootstrap;


window.generateQr = function(e) {
  e.preventDefault();
  e.stopPropagation();
  var code = e.currentTarget.getAttribute('data-code')
  var div = document.querySelector('#code' + code) || document.createElement('div')
  div.id = 'code'+code
  div.innerHTML = '';
  var container = document.querySelector('#qrcode');
  if (!container) {
    container = document.createElement('div');
    container.id = 'qrcode';
    container.style.display = 'none';
    document.body.appendChild(container);
  }
  container.appendChild(div)

  var qrcode = new QRCode(div.id, {
      width: 1024,
      height: 1024,
      colorDark : "#000000",
      colorLight : "#ffffff",
      correctLevel : QRCode.CorrectLevel.H
  });
  qrcode.makeCode(e.currentTarget.href);
  var img = div.querySelector('img')
  var observer = new MutationObserver((changes) => {
    changes.forEach(change => {
        if(change.attributeName.includes('src')){
          const pdf = new jsPDF();
          var width = pdf.internal.pageSize.getWidth() - 40;
          pdf.addImage(img.src, 'png', 20, 20, width, width);
          pdf.save(code + '.pdf')
          observer.disconnect();
        }
    });
  });
  observer.observe(img, {attributes : true});
}

window.editQuestion = function(event) {
  event.preventDefault();
  event.stopPropagation();
  var modal = document.querySelector('#edit-question-modal');
  var el = event.currentTarget;
  var id = el.getAttribute('data-id');
  modal.querySelector('[name=_method]').value = id ? 'PUT' : 'POST';
  var title = modal.querySelector('h2')
  title.innerHTML = title.getAttribute(id ? 'data-update' : 'data-create');
  var submit = modal.querySelector('[type=submit]');
  submit.innerHTML = submit.getAttribute(id ? 'data-update' : 'data-create');
  var deleteBtn = modal.querySelector('#question-delete');
  var form = modal.querySelector('form');
  if (!id) {
    deleteBtn.classList.add('d-none')
    form.setAttribute('action', form.getAttribute('data-action-create'));
    form.reset();
  } else {
    form.setAttribute('action', form.getAttribute('data-action-update').replace('_id_', id));
    form.querySelector('[name=question]').value = el.getAttribute('data-question');
    form.querySelector('[name=tags]').value = el.getAttribute('data-tags');
    form.querySelector('[name=photo_required]').checked = el.getAttribute('data-photo-required') == "1" ? true : false;
    deleteBtn.classList.remove('d-none')
    deleteBtn.href = deleteBtn.getAttribute('data-href').replace('_id_', id);
  }
  setTimeout(function(){
    bootstrap.Modal.getOrCreateInstance(document.querySelector('#edit-question-modal')).show();
  }, 250);
}

window.editSurvey = function(event) {
  event.preventDefault();
  var modal = document.querySelector('#edit-survey-modal');
  var el = event.currentTarget;
  var data = el.getAttribute('data-survey');
  var survey = data ? JSON.parse(data) : null;
  modal.querySelector('[name=_method]').value = survey ? 'PUT' : 'POST';
  var title = modal.querySelector('h2')
  title.innerHTML = title.getAttribute(survey ? 'data-update' : 'data-create');
  var submit = modal.querySelector('[type=submit]');
  submit.innerHTML = submit.getAttribute(survey ? 'data-update' : 'data-create');
  var form = modal.querySelector('form');
  if (!survey) {
    form.setAttribute('action', form.getAttribute('data-action-create'));
    form.reset();
    surveyForm.updateSurvey({
      type: 'text',
      options: {
        default: true
      }
    })
  } else {
    form.setAttribute('action', form.getAttribute('data-action-update').replace('_id_', survey.id));
    surveyForm.updateSurvey(survey)
  }
  setTimeout(function(){
    bootstrap.Modal.getOrCreateInstance(document.querySelector('#edit-survey-modal')).show();
  }, 250);
}